import { a as o, j as e } from "../../../../../emotion-react-jsx-runtime.browser.esm-CsRinUqv.js";
import { IonButton as v } from "@ionic/react";
import { translate as a } from "../../../../string-table.js";
import { Colors as h } from "../../../../1-foundations/Colors/Colors.js";
import { s as f, I as c } from "../../../../../Icon-IZV2yalv.js";
import { J as w, K as W, A as B } from "../../../../../FeatureFlagProvider-C_WBizLB.js";
import "react";
import "../../../../../react-paginate-Lh5zQzpz.js";
import { Section as C } from "../Section/Section.js";
import "../../../LoadingInterstitial/LoadingInterstitial.js";
import "../../../../contexts/DesignSystemProvider/DesignSystemProvider.js";
import '../../../../../css/ContactInfo.css';const E = "_contactInfo_udl9g_1", T = "_swingHeroWrapper_udl9g_7", x = "_swingHeroBanner_udl9g_17", P = "_profileImgWrapper_udl9g_30", H = "_profileImg_udl9g_30", A = "_editButtonWrapper_udl9g_44", b = "_editButton_udl9g_44", y = "_editIconWrapper_udl9g_59", O = "_contactInfoContent_udl9g_64", S = "_contactName_udl9g_72", F = "_email_udl9g_84", r = {
  contactInfo: E,
  swingHeroWrapper: T,
  swingHeroBanner: x,
  profileImgWrapper: P,
  profileImg: H,
  editButtonWrapper: A,
  editButton: b,
  editIconWrapper: y,
  contactInfoContent: O,
  contactName: S,
  "flex-row-center": "_flex-row-center_udl9g_78",
  email: F
};
function V(I) {
  const {
    email: p,
    editable: n,
    name: i,
    phoneNumber: t,
    profileImageUrl: l,
    isPhoneNumberVerified: N = !1,
    badge: d,
    isSwingHero: s = !1
  } = I, m = t ? w({
    phoneNumber: t
  }) : "", _ = t ? m.length > 10 ? t : W({
    phoneNumber: m
  }).value : void 0, g = () => /* @__PURE__ */ o("div", {
    className: r.swingHeroBanner,
    children: [/* @__PURE__ */ e("span", {
      children: a("SUB_PROFILE_CONTACT_SWING")
    }), /* @__PURE__ */ e(c, {
      name: "Swing Hero"
    }), /* @__PURE__ */ e("span", {
      children: a("SUB_PROFILE_CONTACT_HERO")
    })]
  }), u = () => /* @__PURE__ */ o("div", {
    className: r.contactInfoContent,
    children: [i && /* @__PURE__ */ e("div", {
      className: r.contactName,
      children: /* @__PURE__ */ e("span", {
        children: i
      })
    }), t && /* @__PURE__ */ o("div", {
      className: r["flex-row-center"],
      children: [/* @__PURE__ */ e("div", {
        style: d ? {
          alignSelf: "flex-start"
        } : {},
        children: /* @__PURE__ */ e(c, {
          name: "Phone"
        })
      }), /* @__PURE__ */ o("div", {
        children: [/* @__PURE__ */ e("span", {
          style: {
            color: h.black
          },
          children: _
        }), !N && _ && d && /* @__PURE__ */ e("div", {
          style: {
            marginTop: "4px"
          },
          children: d
        })]
      })]
    }), p && /* @__PURE__ */ o("div", {
      className: r["flex-row-center"],
      children: [/* @__PURE__ */ e(c, {
        name: "Mail"
      }), /* @__PURE__ */ e("span", {
        className: r.email,
        children: p
      })]
    })]
  });
  return /* @__PURE__ */ o(C, {
    title: "",
    onEditClick: n != null && n.isEditable ? n.onEditPhoneNumber : void 0,
    children: [/* @__PURE__ */ o("div", {
      className: r.contactInfo,
      style: {
        marginTop: n != null && n.isEditable ? "-24px" : 0
      },
      children: [/* @__PURE__ */ o("div", {
        style: {
          width: 92,
          position: "relative"
        },
        children: [l ? s ? /* @__PURE__ */ o("div", {
          className: r.swingHeroWrapper,
          children: [/* @__PURE__ */ e("div", {
            className: r.profileImgWrapper,
            children: /* @__PURE__ */ e("img", {
              src: l,
              alt: i,
              className: r.profileImg
            })
          }), /* @__PURE__ */ e(g, {})]
        }) : /* @__PURE__ */ e("div", {
          className: r.profileImgWrapper,
          children: /* @__PURE__ */ e("img", {
            src: l,
            alt: i,
            className: r.profileImg
          })
        }) : s ? /* @__PURE__ */ o("div", {
          className: r.swingHeroWrapper,
          children: [/* @__PURE__ */ e("div", {
            className: r.profileImgWrapper,
            children: /* @__PURE__ */ e("img", {
              src: f,
              alt: a("SUB_PROFILE_CONTACT_IMAGE_ALT"),
              style: {
                width: 92
              }
            })
          }), /* @__PURE__ */ e(g, {})]
        }) : /* @__PURE__ */ e("img", {
          src: f,
          alt: a("SUB_PROFILE_CONTACT_IMAGE_ALT"),
          style: {
            width: 92
          }
        }), (n == null ? void 0 : n.isEditable) && /* @__PURE__ */ e("div", {
          className: r.editButtonWrapper,
          style: s ? {
            bottom: "10px",
            right: "-14px"
          } : {},
          children: /* @__PURE__ */ e(v, {
            className: r.editButton,
            size: "small",
            shape: "round",
            onClick: n.onEditAvatar,
            children: /* @__PURE__ */ e("div", {
              className: r.editIconWrapper,
              children: /* @__PURE__ */ e(c, {
                name: "Edit",
                color: h.white200
              })
            })
          })
        })]
      }), (i || p || t) && /* @__PURE__ */ e(u, {})]
    }), !l && /* @__PURE__ */ e("div", {
      style: {
        marginTop: s ? "20px" : "8px"
      },
      children: /* @__PURE__ */ e(B, {
        color: "warning",
        children: a("SUB_PROFILE_NO_IMAGE_TEXT")
      })
    })]
  });
}
export {
  V as ContactInfo
};
